<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  metaInfo () {
    const isProd = process.env.NODE_ENV === 'production'
    if (isProd) {
      return {
        meta: [
          { name: 'google-site-verification', content: 'PGI8Df1akrJLYTmKQbUvveOzq-oORVhABnox7YB30zE' }
        ],
        script: [
          { src: 'https://platform.twitter.com/widgets.js', async: true }
        ],
        bodyAttrs: {
          class: 'homepage'
        }
      }
    }
    return {
      script: [
        { src: 'https://platform.twitter.com/widgets.js', async: true }
      ],
      bodyAttrs: {
        class: 'homepage'
      }
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'production') {
      let startComment = document.createComment(' This site is converting visitors into subscribers and customers with OptinMonster - https://optinmonster.com ')
      let endComment = document.createComment(' / OptinMonster ')
      let optinMonster = document.createElement('script')
      optinMonster.setAttribute('src', 'https://a.omappapi.com/app/js/api.min.js')
      optinMonster.setAttribute('data-account', '137854')
      optinMonster.setAttribute('data-user', '125552')
      document.body.appendChild(startComment)
      document.body.appendChild(optinMonster)
      document.body.appendChild(endComment)
    }
    let recaptchScript = document.createElement('script')
    recaptchScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.body.appendChild(recaptchScript)
  }

}
</script>
<style>
  body, button, input, select, textarea, * {
    font-family: "Open Sans", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }

  .spinner {
    width: 50px;
    display: block;
    margin: 0 auto;
  }

  @media screen and (max-width: 767px) {
    .modal.is-active ~ .router-view {
      display: none;
    }
  }

  *:focus {
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue